const Footer = () => {
  return (
    <footer className="ft_main">
      <div className="ft_top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="ft_about">
                <h5 className="ft_heading">
                  <img
                    src={require('assets/images/ft_logo.png').default}
                    alt="logo"
                    className="ft_logo img-responsive"
                  />
                  <span>who we are</span>
                </h5>
                <p>
                  Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
                  Aenean commodo ligula eget dolor. Aenean massa. Cum sociis
                  natoque penatibus et magnis dis parturient montes, nascetur
                  ridiculus mus. Donec quam felis, ultricies nec, pellentesque
                  eu, pretium quis, sem. Nulla consequat massa quis enim. Donec
                  pede{' '}
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="ft_menu_area d-flex">
                <div className="ft_menu_col">
                  <h5 className="ft_heading">important links</h5>
                  <ul className="ft_menu_list">
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        About Fabikraft
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Help
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Terms &amp; Conditions
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Return Policies
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Shipping
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Contact us
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Privacy
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Careers
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="ft_menu_col">
                  <h5 className="ft_heading">products</h5>
                  <ul className="ft_menu_list">
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Lorem ipsum dolor sit
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Consectetuer
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Adipiscing elit.
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Ommodo{' '}
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Eget dolor.
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Aenean
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Cum sociis natoque
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        <b>All Products</b>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="ft_menu_col">
                  <h5 className="ft_heading">brands</h5>
                  <ul className="ft_menu_list">
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Lorem ipsum dolor sit
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Consectetuer
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Adipiscing elit.
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Ommodo{' '}
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Eget dolor.
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Aenean
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        Cum sociis natoque
                      </a>
                    </li>
                    <li>
                      <a href="/" onClick={(e) => e.preventDefault()}>
                        <b>All Brands</b>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <div className="ft_contact">
                <h5 className="ft_heading">get in touch</h5>
                <ul className="ft_menu_list">
                  <li>
                    <a href="/" onClick={(e) => e.preventDefault()}>
                      <span className="contact_icon">
                        <img
                          src={require('assets/images/map.png').default}
                          alt="map"
                        />
                      </span>
                      <span className="ft_address">
                        91 Springboard BKC, Mumbai, India
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:+919892331385">
                      <span className="contact_icon">
                        <img
                          src={require('assets/images/phone.png').default}
                          alt="phone"
                        />
                      </span>
                      <span className="ft_address">
                        <small>+91&nbsp;9892331385</small>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:fab@fabikraft.com">
                      <span className="contact_icon">
                        <img
                          src={require('assets/images/mail.png').default}
                          alt="mail"
                        />
                      </span>
                      <span className="ft_address">fab@fabikraft.com</span>
                    </a>
                  </li>
                </ul>
                <h5 className="ft_heading diff">payment</h5>
                <ul className="pay_mode d-flex">
                  <li>
                    <img
                      src={require('assets/images/visa.png').default}
                      className="img-responsive"
                      alt="visa"
                    />
                  </li>
                  <li>
                    <img
                      src={require('assets/images/mc.png').default}
                      className="img-responsive"
                      alt="mastercard"
                    />
                  </li>
                  <li>
                    <img
                      src={require('assets/images/paypal.png').default}
                      className="img-responsive"
                      alt="paypal"
                    />
                  </li>
                  <li>
                    <img
                      src={require('assets/images/amricanex.png').default}
                      className="img-responsive"
                      alt="americanex"
                    />
                  </li>
                  <li>
                    <img
                      src={require('assets/images/upi.png').default}
                      className="img-responsive"
                      alt="upi"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ft_bottom">
        <div className="container">
          <ul className="social_media_list">
            <li>
              <a href="/" onClick={(e) => e.preventDefault()} target="_blank">
                <i className="fab fa-facebook-f" />
              </a>
            </li>
            <li>
              <a href="/" onClick={(e) => e.preventDefault()} target="_blank">
                <i className="fab fa-twitter" />
              </a>
            </li>
            <li>
              <a href="/" onClick={(e) => e.preventDefault()} target="_blank">
                <i className="fab fa-google-plus-g" />
              </a>
            </li>
            <li>
              <a href="/" onClick={(e) => e.preventDefault()} target="_blank">
                <i className="fab fa-linkedin-in" />
              </a>
            </li>
            <li>
              <a href="/" onClick={(e) => e.preventDefault()} target="_blank">
                <i className="fab fa-youtube" />
              </a>
            </li>
          </ul>
          © Copyright 2021 FABIKRAFT - All Rights Reserved
        </div>
      </div>
    </footer>
  );
};

export default Footer;
